import { makeStyles } from "@material-ui/core/styles";

export const useLoadingStyles = makeStyles({
  container: {
    height: "auto",
    marginTop: 0,
    flex: 1,
  },
});
